const config = {
  ui: {
    colors: {
      primary: 'primary',
      info: 'info',
      success: 'success',
      secondary: 'secondary',
      warning: 'warning',
      neutral: 'neutral',
      error: 'error',
    },
    button: {
      slots: {
        base: 'cursor-pointer',
      },
      variants: {
        variant: {
          link: 'underline',
        },
      },
    },
    selectMenu: {
      slots: {
        base: 'cursor-pointer',
        item: 'cursor-pointer',
      },
      variants: {
        variant: {
          subtle: 'bg-(--ui-primary-50)',
        },
      },
    },
    modal: {
      variants: {
        fullscreen: {
          false: {
            content: 'w-full max-w-2xl',
          },
        },
      },
    },
    formField: {
      slots: {
        error: 'cy-error-class',
      },
    },
  },
};

export default config;
